let spamAlertRecentlyShown = false;

export function getSpamAlertState() {
  return spamAlertRecentlyShown;
}

export function setSpamAlertState(value) {
  spamAlertRecentlyShown = value;
}